<template>
  <b-modal id="modal-stock-movement" v-model="visible" hide-footer centered no-close-on-backdrop v-if="product_id"
    @hidden="setInUrl(null)">
    <template slot="modal-title">Enregistrer un mouvement de stock</template>
    <b-form @submit.prevent="addMovement">
      <b-form-group label="Type de mouvement" label-for="type">
        <b-form-radio-group id="type" v-model="movement_type" :options="[
          { value: 'product-add-stock', text: 'Entrée' },
          { value: 'product-remove-stock', text: 'Sortie' },
        ]" buttons button-variant="outline-primary" :required="true"></b-form-radio-group>
      </b-form-group>
      <b-form-group label="Entrepôt" label-for="warehouse">
        <b-form-select id="warehouse" v-model="movement_warehouse_id" :options="warehouse_select_options"
          :required="true">
          <template slot="first">
            <option :value="null" disabled>-- Choisir un entrepôt --</option>
          </template>
        </b-form-select>
      </b-form-group>
      <b-form-group label="Quantité" label-for="quantity">
        <b-form-input id="quantity" type="number" v-model="movement_quantity" :required="true" />
      </b-form-group>
      <b-form-group v-if="movement_type == 'product-add-stock'" label="Prix d'achat unitaire HT"
        label-for="purchase_price">
        <b-form-input id="purchase_price" type="number" v-model="movement_purchase_price" step="0.01" />
      </b-form-group>
      <b-form-group v-if="movement_type == 'product-add-stock'" label="N° de commande" label-for="order_number">
        <b-form-input id="order_number" type="text" v-model="movement_order_number" />
      </b-form-group>
      <b-form-group label="Commentaire" label-for="comment">
        <b-form-textarea id="comment" type="text" v-model="movement_comment" :required="false" />
      </b-form-group>
      <b-button type="submit" variant="primary" class="ml-auto" :disabled="inSaving">
        Enregistrer
        <i class="fa fa-chevron-right"></i>
      </b-button>
    </b-form>
  </b-modal>
</template>

<script>
import config from "./config";

/**
 * Modale « Enregistrer un mouvement de stock » d'un produit à la vente, partagée par la liste
 * et la fiche produit. Ouverte par open(product), elle porte ?movement=<id> dans l'URL tant
 * qu'elle est affichée : la page la rouvre au chargement (lien partagé, rafraîchissement).
 * Émet `saved` une fois le mouvement enregistré et le produit rechargé.
 */
export default {
  name: "StockMovementModal",
  data() {
    return {
      product_id: null,
      visible: false,
      movement_quantity: null,
      movement_comment: null,
      movement_purchase_price: null,
      movement_order_number: null,
      movement_type: "product-add-stock",
      movement_warehouse_id: null,
      inSaving: false,
    };
  },
  computed: {
    warehouse_select_options() {
      return this.$store.getters["warehouse/getAll"].selectOptions("id", ["internal_code", " - ", "name"]);
    },
  },
  mounted() {
    this.$store.dispatch("warehouse/getAll");
  },
  methods: {
    open(product) {
      this.product_id = product.id;
      this.movement_purchase_price = product.purchase_price;
      // Par défaut : l'entrepôt filtré dans la liste, sinon celui de l'utilisateur
      const filtered = parseInt(this.$route.query.warehouse);
      const own = this.$store.getters["auth/warehouse"];
      this.movement_warehouse_id = filtered || (own && own.id) || null;
      this.setInUrl(product.id);
      this.visible = true;
    },
    setInUrl(productId) {
      const query = Object.assign({}, this.$route.query);
      if (productId) {
        if (query.movement === String(productId)) return;
        query.movement = String(productId);
      } else {
        if (!query.hasOwnProperty("movement")) return;
        delete query.movement;
      }
      this.$router.replace({ query }).catch(() => {});
    },
    addMovement() {
      if (!this.product_id || !this.movement_quantity) {
        return;
      }
      this.inSaving = true;
      this.$store
        .dispatch("product_log/addItem", {
          quantity: this.movement_quantity,
          comment: this.movement_comment,
          status_slug: this.movement_type,
          product_id: this.product_id,
          warehouse_id: this.movement_warehouse_id,
          purchase_price:
            this.movement_type == "product-add-stock" ? this.movement_purchase_price : null,
          order_number:
            this.movement_type == "product-add-stock" ? this.movement_order_number : null,
        })
        .then(() => this.$store.dispatch(config.storeNamespace + "/getItem", { id: this.product_id, wait: true }))
        .then(() => {
          this.visible = false;
          this.$emit("saved", this.product_id);
          this.movement_quantity = null;
          this.movement_comment = null;
          this.movement_purchase_price = null;
          this.movement_order_number = null;
          this.movement_type = "product-add-stock";
        })
        .catch(() => {
          this.$toastr.error("L'enregistrement du mouvement a échoué");
        })
        .finally(() => {
          this.inSaving = false;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Product/StockMovementModal.vue